import { render, staticRenderFns } from "./ToothNumberButtons.vue?vue&type=template&id=dc96a4ae&scoped=true&"
import script from "./ToothNumberButtons.vue?vue&type=script&lang=js&"
export * from "./ToothNumberButtons.vue?vue&type=script&lang=js&"
import style0 from "./ToothNumberButtons.vue?vue&type=style&index=0&id=dc96a4ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc96a4ae",
  null
  
)

export default component.exports